const API = '/api/v1/ambassadors';
const PENDING_KEY = 'jobseeqr.ambassador.signup';
export const AMBASSADOR_EVENT = 'jobseeqr:ambassador';
export const ambassadorSignupEnabled = process.env.REACT_APP_AMBASSADOR_PROGRAM_ENABLED === 'true';

async function request(user, path, body) {
  const token = await user.getIdToken();
  const response = await fetch(`${API}${path}`, {
    method: body ? 'POST' : 'GET',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.detail || 'Could not apply your ambassador code. Please try again.');
  return result;
}

export const getAmbassador = (user) => request(user, '/me');
export async function redeemAmbassador(user, code, source = 'Profile') {
  const result = await request(user, '/redeem', { code: code.trim(), source });
  window.dispatchEvent(new Event(AMBASSADOR_EVENT));
  return result;
}

export function saveSignupCode(user, code) {
  if (!code.trim()) return;
  window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({ uid: user.uid, code: code.trim() }));
  window.dispatchEvent(new Event(AMBASSADOR_EVENT));
}
export function pendingSignupCode(user) {
  try {
    const value = JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
    return value?.uid === user?.uid ? value.code : '';
  } catch { return ''; }
}
export function clearSignupCode() {
  window.sessionStorage.removeItem(PENDING_KEY);
  window.dispatchEvent(new Event(AMBASSADOR_EVENT));
}
